import React from "react";

class TestimonialScroll extends React.Component {
    render() {
        return (
            <div></div>
        );
    }
}


export default TestimonialScroll;